import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-data-submitted',
    imports: [
        TranslocoPipe
    ],
    templateUrl: './data-submitted.component.html',
    styleUrl: './data-submitted.component.scss'
})
export class DataSubmittedComponent {

}
